module.exports = __webpack_public_path__ + "static/img/_.yunshangzg.com.49825b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_.yunshangzg.com.svg
// module id = LXtb
// module chunks = 41